

export const customColors = {
    // Text
    textPrimary: "#275342",
    textPalette1: "#2E614D",
    textPalette2: "#3B7D62",
    textPalette3: "#489977",
    textPalette4: "#59B18C",
    textPalette5: "#74BE9F",
    appColor1: "#edeec9",
    appColor2: "#dde7c7",
    appColor3: "#bfd8bd",
    appColor4: "#98c9a3",
    appColor5: "#77bfa3",

    appColor6: "#F7E9DD",
    appColor7: "#f12121",
    appColor8red: "#D23D42",
    appColor9: "#b7e4c5",
    appColor10: "#f19696",
    appColor11: "#f5d9ff",
    appColor12: "#d9f2e6",
    

    redColor :  "#FEC9B9",
    greenColor :  "#5FAB1F",
    redColor2 :  "#fa6262",
    greenColor2 :  "#8cb36c",

    redColorLight: "#ffb3b3",

    backgroundLight: "#f2ffe6"

}


